import BigNumber from "bignumber.js";

export function formatPercentage(value: number, decimalPlaces?: number): string {
  return `${new BigNumber(value).decimalPlaces(decimalPlaces ?? 2).toNumber()} %`;
}
